$(document).ready(function () {
  $(document).click(function(event) {
    setTimeout(function(){
      if ($('.mega-menu[open], #Details-menu-drawer-container[open], .header__search details[open] ').length) {
        $('body').addClass('mega-menu-active');
      } else {
        $('body').removeClass('mega-menu-active');
      }
    },10);
    setTimeout(function(){
      if ($('.mega-menu[open], #Details-menu-drawer-container[open], .header__search details[open]').length) {
        $('body').addClass('mega-menu-active');
      } else {
        $('body').removeClass('mega-menu-active');
      }
    },550);
    
  });

  

  //MC VALIDATE
  (function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='MNUMB';ftypes[3]='phone';fnames[4]='WEDDATE';ftypes[4]='text';fnames[5]='APPLAST';ftypes[5]='date';fnames[6]='APPNEXT';ftypes[6]='date';fnames[7]='APPCOUNT';ftypes[7]='number';}(jQuery));var $mcj = jQuery.noConflict(true);
  
});


// POPUP 
// Wrap code in document ready
jQuery(document).ready(function($) {

  // Check if the body doesn't have the .home class
  if (!$('body').hasClass('home')) {

    // Your existing popup code goes here

    $('.popup-close, .popup-overlay').click(function() {
      $('.popup').addClass('hidden');
      $('body').removeClass('popup-active');
    });

    setTimeout(function() {
      $('.popup').addClass('active');
      $('body').addClass('popup-active');

      //POPUP EXPIRY TIMER
      if($('.popup.popup-expiry-active').length) {
        var currentTime = new Date().getTime();
        $('.popup-close, .popup-overlay').click(function() {
          localStorage.setItem('popUpHidden', true);
          localStorage.setItem('timeClosed', currentTime);
        });
        if(localStorage.getItem('popUpHidden', true)) {
          $('.popup.popup-expiry-active').addClass('hidden');
          $('.popup').removeClass('active');
          $('body').removeClass('popup-active');
        }

        var closedTime = parseInt(localStorage.getItem('timeClosed'));
        var popupExpiry = 86400000*30; //24hrs in ms * 30 Days
        //var popupExpiry = 100; //For Development
        console.log(popupExpiry);

        if(currentTime >= closedTime + popupExpiry) {
          localStorage.setItem('popUpHidden', false);
          $('.popup.popup-expiry-active').removeClass('hidden');
        }
      }
    }, 3000);

  }
});
